import React from 'react';
import styles from './Hyperlink.module.css';
import { joinClassNames } from '@utils/joinClassNames';

const Hyperlink = ({ children, className, href }) => {
  const cssClasses = joinClassNames([styles.link, className ?? '']);
  const showLink = href.trim() && ((typeof children === 'string' && children.trim()) || children);
  return showLink ? (
    <a href={href.trim()} className={cssClasses}>
      {children}
    </a>
  ) : null;
};

export default Hyperlink;
